export default __webpack_public_path__ + "static/media/Branding.9784fa9f.svg";